export default __webpack_public_path__ + "static/media/translate.2127d3d9.png";